import React, { useEffect, useState } from 'react'
import List from '../../components/List'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { getLocationTopology } from '../../services/locationTopology'
import direction from '../../utils/filterDirectionOrder'
import { stringCompare } from '../../utils/sorters'
import SelectInput from "../../components/UI/SelectInput";
import Input from "../../components/UI/Input";
import ActionArea from "../../components/ActionArea";
import { sendSystemLog } from '../../context/AuthProvider/useAuth'

function index() {
  const loading = useLoading()
  const [list, setList] = useState([
    {
      location: '',
      distributor: '',
      server: ''
    }
  ])
  const [filter, setFilter] = useState<string>('')
  const log = {
    log_type: 'visited',
    log_object: 'location_topology'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])
  

  useEffect(() => {
    (async () => {
      const res = await getLocationTopology()
      setList(res)
    })()
  },[])

  const handleEnter = (event: KeyboardEvent) => {
    if (loading.loading) return;
    if (!event.repeat && event.key === 'Enter') {
      onRefresh()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEnter)
    return () => document.removeEventListener("keydown", handleEnter)
  })

  const onRefresh = async () => {
    loading.addLoading()
    let params = {
      search: filter  || ''
    }

    const res = await getLocationTopology(params)
    if(res) setList(res)
    loading.removeLoading()
  }

  return (
    <>
      <ActionArea innerProps={{id: 'accounts_refresh'}} buttonAction={onRefresh} buttonText={'Search'}>
        <>
          <Input
              label="Search"
              onChange={(e: any) => setFilter(e.target.value )}
              value={filter}
              style={{marginBottom: 0}}
          />
        </>
      </ActionArea>
      <List
        rows={list}
        pagination
        columns={[
          {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
            render: (value: any, record: any) => value,
            sorter: (a: typeof list[0], b: typeof list[0]) => stringCompare(a.location, b.location)
          },
          {
            title: 'Server',
            dataIndex: 'server',
            key: 'server',
            render: (value: any, record: any) => value,
            sorter: (a: typeof list[0], b: typeof list[0]) => stringCompare(a.server, b.server),
          },
          {
            title: 'Distributor',
            dataIndex: 'distributor',
            key: 'distributor',
            render: (value: any, record: any) => value || '--',
            sorter: (a: typeof list[0], b: typeof list[0]) => stringCompare(a.distributor, b.distributor),
          },
        ]}
      />
    </>
  )
}

export default index